<script>
    import { Basket } from '../lib/stores/basket';
	import {REST} from '../utils/rest';
	let mobile="";
	let error = "";
	let addresses = [];
	const getAddresses = async () => {
		if(mobile.length!=10){
			error = "Please enter a valid mobile number";
		}else{
			error = "";
			let res = await fetch(`https://crm.lamara.in/products/products/customer_addresses/${mobile}`);
			res = await res.json();
			if(res.error || res.data && res.data.old_addresses.length == 0){
				$Basket.shipping = {
					mobile: mobile
				}
			}else{
				addresses = res.data.old_addresses;
			}
		}
	}

	const selectAddress = async (address) => {
		$Basket.shipping = {
			mobile: mobile,
			shippingAddress: {...address, phone: mobile}
		}
	}
</script>
<section class="banner-section">
	<div class="container">
		<h1>
			Mobile Number
		</h1>
	</div>
</section>
<section id="" class="page-content">
	<div class="container">
		<div class="content-box">
			<section id="" class="form-page">
				<div class="container">
					{#if addresses.length == 0}
					<div class="col-md-6 container bg-default">
						<form on:submit|preventDefault={getAddresses}>
							<div class="form-row">
								<div class="col-md-12 form-group">
									<label class="lbl-txt" for="">Enter your mobile number:</label>
									<input type="tel" bind:value={mobile} inputmode=”numeric” class="form-control" maxlength="10"  placeholder="Mobile Number" on:change={e => error = ""}>
									{#if error!=""}
										<div class="invalid-feedback">
											{error}
										</div>
									{/if}
								</div>
							</div>
							<hr class="mb-4">
							<button class="btn btn-primary bt-lg btn-block" type="submit" disabled={mobile.length!=10}  >Continue</button>
						</form>
					</div>
					{:else}
						Where do you want to ship to?
						{#each addresses as address}
							<div class="col-12 card my-2 py-2" on:click|preventDefault={e => selectAddress(address)}>
								{address.address}
							</div>
						{/each}
						<div class="col-12 card my-2 py-2" on:click={e => {
							$Basket.shipping = {
								mobile: mobile
							}
						}}>
							Somewhere else
						</div>
					{/if}
				</div>
			</section>
		</div>
	</div>
</section>
<style >
	h1 {
		font-family: 3em;
		font-family: var(--primary-font);
		font-weight: 600;
		margin-top: 50px;
	}

	.section-title {
		padding: 6em 0 1em 0;
	}

	.form-page {
		padding-top: 150px;
		padding-bottom: 100px;
		min-height: 80vh;
	}

	.invalid-feedback{
		display: block;
	}
	
	.banner-section {
		background: rgba(0, 0, 0, 0.6);
		min-height: 80px;
		padding-top: 20px;
	}

	.banner-section h1 {
		margin-top: 0;
		font-size: 30px;
	}
</style>